import { render, staticRenderFns } from "./Newjoin.vue?vue&type=template&id=7161dab6"
import script from "./Newjoin.vue?vue&type=script&lang=js"
export * from "./Newjoin.vue?vue&type=script&lang=js"
import style0 from "./Newjoin.vue?vue&type=style&index=0&id=7161dab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports